import React from 'react';
import { Users } from 'lucide-react';

interface WalletStatCardsProps {
  totalDistributors?: number;
}

export const WalletStatCards: React.FC<WalletStatCardsProps> = ({
  totalDistributors = 0,
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-6 select-none">
      {/* Total Distributors */}
      <div className="bg-white rounded-2xl p-5 border border-[#ECECF2] shadow-sm flex items-center gap-4 hover:shadow-md transition-shadow">
        <div className="w-12 h-12 rounded-2xl bg-rose-100/70 text-[#B71C1C] flex items-center justify-center shrink-0">
          <Users className="w-6 h-6" />
        </div>
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-slate-500">Total Distributors</span>
          <span className="text-2xl font-extrabold text-slate-800 tracking-tight mt-0.5">
            {totalDistributors}
          </span>
          <span className="text-[11px] font-bold text-emerald-600 mt-1">
            Registered Network
          </span>
        </div>
      </div>
    </div>
  );
};

export default WalletStatCards;
